import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { url } from "./settings";
import * as serviceWorker from "./serviceWorker";
import { authHeaders, getRefreshToken, refreshTokens } from "./auth";

// Apollo
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  HttpLink,
  from,
  fromPromise,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

// Bearer token on every request (see auth.js). `credentials: "include"` stays
// for the transition: a user whose session cookie predates token login is
// still signed in until they log in again and receive tokens.
const httpLink = new HttpLink({ uri: `${url}/graphql/`, credentials: "include" });

const authLink = setContext((_, { headers }) => ({
  headers: authHeaders(headers),
}));

// The API answers 401 when the access token has expired: refresh once and
// replay the request with the new token.
const refreshLink = onError(({ networkError, operation, forward }) => {
  if (networkError && networkError.statusCode === 401 && getRefreshToken()) {
    return fromPromise(refreshTokens()).flatMap((refreshed) => {
      if (!refreshed) throw networkError;
      operation.setContext(({ headers = {} }) => ({ headers: authHeaders(headers) }));
      return forward(operation);
    });
  }
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authLink, refreshLink, httpLink]),
  resolvers: {},
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App client={client} />
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
